import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Sharedservice } from './../../shared-components/shared.service';

@Component({
  standalone: false,
  selector: 'app-loadengagement',
  templateUrl: './loadengagement.component.html',
  styleUrls: ['./loadengagement.component.css']
})
export class LoadEngagementComponent {
  constructor(private route: ActivatedRoute, private sharedService: Sharedservice) { }
}

